module.exports = __webpack_public_path__ + "img/modal-left-3.a323895b.png";